import React from 'react';
import './App.css';

const quality = ["", "", "", "Excellent", "Masterpiece"];

function getLootId() {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get('loot_id') || '';
}

function App(props) {
    const [data, setData] = React.useState([]);
    const [totals, setTotals] = React.useState(null);

    function loadLoot() {
        let loot_id = getLootId();
        if (loot_id !== '') {
            fetch(
                "https://albion-mysql-access-jggak.transposit.io/api/v1/execute/loot_split_load",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        parameters: {
                            "loot": loot_id
                        }
                    })
                }
            ).then((response) => {
                return response.json();
            }).then((data) => {
                if (data.result.results == null) {
                    setTotals("Retrying in 5s...");
                    setTimeout(calculate, 5000);
                    return;
                }
                var result = data.result.results[0];
                setTotals(fn(result.min_total) + " / " +
                    fn(result.median_total));
                setData(result.prices);
                document.getElementById("items").value = result.loot;
            });
        }
    }

    React.useEffect(loadLoot, []);

    function calculate() {
        setData([]);
        setTotals("Loading...");
        let loot = document.getElementById("items").value;

        fetch(
            "https://albion-mysql-access-jggak.transposit.io/api/v1/execute/loot_split_save",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    parameters: {
                        "loot": loot
                    }
                })
            }
        ).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.result.results == null) {
                setTotals("Retrying in 5s...");
                setTimeout(calculate, 5000);
                return;
            }
            var loot_id = data.result.results[0].result;
            window.history.replaceState({loot_id:loot_id}, "Loots", '/?loot_id=' + loot_id);
            loadLoot();
        });
    }

    return (
        <div className="App">
            <h1>Chest loot sale value calculator</h1>
            <p>Copy the loot log from the chest, including all pages until the last time it was cleared out.
                You may need to wait a couple minutes for the chest log to update after the last item is added or
                removed.</p>
            <p>Total -4.5% (minimum/median): <span id="total">{totals}</span></p>
            <div>
                {table(data)}
            </div>
            <p>&nbsp;</p>
            <div>
                <textarea id="items"></textarea>
            </div>
            <div>
                <input type="button" value="Get Value" onClick={calculate}/>
            </div>
            <a href="https://savagealbion.com"><img alt="Savage" src="https://savagealbion.com/img/savage.svg"/></a>
        </div>

    );
}

function table(data) {
    if (data.length === 0) return "";
    data.sort((a,b) => {
        a = a.min_price;
        b = b.min_price;
        if (!a) a = 0;
        if (!b) b = 0;
        return b-a;
    });
    var key = 0;
    return  <table>
        <thead>
        <tr>
            <th>Item</th>
            <th>Name</th>
            <th>Number</th>
            <th>Minimum</th>
            <th>Median</th>
            <th>Total Minimum</th>
            <th>Total Median</th>
        </tr>
        </thead>
        <tbody>
        {data.map((price) => {
            return <tr key={key++}>
                <td><img alt={price.name} width="48" height="48" src={"https://render.albiononline.com/v1/item/" + price.item + (price.enchantment > 0 ? "@" + price.enchantment : "") +
                "?count=" + price.amount + "&quality=" + (price.quality + 1)}/></td>
                <td>{quality[price.quality]} {price.name} .{price.enchantment}</td>
                <td>{price.amount}</td>
                <td>{fn(parseInt(price.min_price))}</td>
                <td>{fn(parseInt(price.median_price))}</td>
                <td>{fn(price.amount * parseInt(price.min_price))}</td>
                <td>{fn(price.amount * parseInt(price.median_price))}</td>
            </tr>;
        })}
        </tbody>
    </table>;
}

function fn(num) {
    if (isNaN(num)) num = 0;
    return parseInt((num * .955).toString()).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export default App;
